<div class="acceptance-agreement justify-content-center h-100">
    <div class="content h-100">
        <div class="content-icon">
            <i class="icon-edponline-Bra-072 custom-icon"></i>
        </div>

        <p [innerHTML]="'pt.edp.edponline.acceptance.agreement.title' | translate"></p>

        <ng-container *ngIf="isNumber">
            <p
                class="description"
                [innerHTML]="
                    'pt.edp.edponline.acceptance.agreement.description.mobile'
                        | translate: { INSTALLMENT: paymentAgreementTerm.data?.firstValue, CONTACT: contact.contact }
                "
            ></p>
        </ng-container>
        <ng-container *ngIf="!isNumber">
            <p
                class="description"
                [innerHTML]="
                    'pt.edp.edponline.acceptance.agreement.description.email'
                        | translate: { INSTALLMENT: paymentAgreementTerm.data?.firstValue, CONTACT: contact.contact }
                "
            ></p>
        </ng-container>

        <div class="custom-buttons">
            <button class="custom-buttom" (click)="goBack()">
                {{ "pt.edp.edponline.acceptance.agreement.buttom" | translate }}
            </button>
        </div>
    </div>
</div>
